import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ExceptionResolution } from '@usf/ngrx-order';
import { ImageVariantEnum } from 'src/app/product-detail/models/image-variant.enum';
import { getFirstImageURL } from 'src/app/product-detail/utils/product-images.util';
import { Product } from 'src/app/shared/models/product.model';
import { ExceptionType } from '../../../pages/order-exceptions/constants/order-exception-type.enum';
import { ResolutionType } from '../../../pages/order-exceptions/constants/resolution-type.enum';
import { EmittedResolution } from '../../../pages/order-exceptions/models/emitted-resolution.model';
import { ProductSummary } from '@usf/product-types';
import { getAlternativeThumbnail } from 'src/app/product-detail/utils/product-images.util';
import { HandPricingProductDetails } from '../../../models/order-view-model';

@Component({
  template: '',
})
export class PricingRowBaseComponent implements OnChanges {
  @Input() exceptionResolution: ExceptionResolution;
  @Input() product: Product;
  @Input() exceptionType: ExceptionType;
  @Output() updatePriceEmitter = new EventEmitter<HandPricingProductDetails>();
  thumbnailImageURL: string;
  xlargeImageURL: string;
  @Input() productState: ProductSummary;
  @Input() isOffline: boolean;

  @Input() sellerPrice: any;
  @Output() exceptionResolved = new EventEmitter();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.product?.currentValue) {
      this.thumbnailImageURL = getFirstImageURL(
        changes.product.currentValue.summary,
        ImageVariantEnum.Thumbnail,
      );
      this.xlargeImageURL = getFirstImageURL(
        changes.product.currentValue.summary,
        ImageVariantEnum.XLarge,
      );
    }
  }

  getAternativeThumbnail = (thumbnailImageURL: string): string =>
    getAlternativeThumbnail(this.productState, thumbnailImageURL);

  emitProductDetails() {
    this.updatePriceEmitter.emit({
      currentDetails: {
        productNumber: this.product.productNumber,
        brand: this.product.summary.brand,
        breakable: this.product.summary.breakable,
        description: this.product.summary.productDescTxtl,
        packSize: this.product.summary.salesPackSize,
        eachPrice: this.exceptionResolution.orderItem.eachPrice,
        eachUom: this.product.summary.eachUom,
        currentPrice: this.exceptionResolution.orderItem.unitPrice,
        priceUom: this.exceptionResolution.orderItem.priceUOM,
        thumbnailImageURL: this.thumbnailImageURL,
        xlargeImageURL: this.thumbnailImageURL,
        orderException: this.exceptionResolution.orderException,
        orderItem: this.exceptionResolution.orderItem,
        currentPriceOverride: this.exceptionResolution.resolutionOrderItem
          ?.originalProduct?.unitPriceOverride,
      },
      exceptionResolution: this.exceptionResolution,
    });
  }

  edit() {
    const resolution: EmittedResolution = {
      exceptionResolution: { ...this.exceptionResolution, expanded: true },
      resolutionType: ResolutionType.PRICE,
    };
    this.exceptionResolved.emit(resolution);
  }

  isPriceASCIncluded(productNumber: number) {
    return (
      this.sellerPrice &&
      this.sellerPrice[productNumber]?.customerAscInd === 'P'
    );
  }
}
